import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Grid, Segment, Icon, Header, Menu, Message, Breadcrumb } from 'semantic-ui-react';
import { monitoramentoErrosAction } from '../../actions/MonitoramentoActions';
import 'semantic-ui-css/components/menu.css';
import 'semantic-ui-css/semantic.min.css';
import { TabPane, ListItem, List, Label, Tab } from 'semantic-ui-react'

const cardcontent = {
    border: '1px solid #1884af',
    borderRadius: '10px',
}

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            erros: []
        };
    }



    componentDidMount() {
        const { menu, history, monitoramentoErrosAction } = this.props;
        if (menu.length === 0) {
            history.push('/');
        } else {
            const itemMonitoramento = menu.find(item => item.nome === 'Monitoramento' && item.status === 1);
            if (itemMonitoramento) {
                monitoramentoErrosAction().then(dados => {
                    // this.setState({ erros: dados.descricao });
                });
            }
        }
        const itemMonitoramento = menu.find(item => item.nome === 'Monitoramento' && item.status === 1);

        // Inicia o setInterval para chamar monitoramentoErrosAction a cada 5 segundos
        if (itemMonitoramento) {
            this.interval = setInterval(() => {
                monitoramentoErrosAction();
            }, 60000);
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.moniterros !== this.props.moniterros) {
            this.updateErros(this.props.moniterros);
        }
    }

    componentWillUnmount() {
        // Limpa o setInterval quando o componente for desmontado para evitar memory leaks
        clearInterval(this.interval);
    }

    updateErros(moniterros) {
        const erros = moniterros.map(erro => `ID(${erro.idmonit}) - ${erro.descricao} parado a mais de ${parseInt(erro.minutos)} minutos - Ocorrência em: ${new Date(erro.dtocorrencia).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        })}`);
        this.setState({ erros });
    }

    render() {
        const { menu } = this.props;
        const { erros } = this.state;

        // console.log(erros);
        const itemMonitoramento = menu.find(item => item.nome === 'Monitoramento' && item.status === 1);

        return (
            <div style={{ padding: '1em 0' }}>
                <Menu stackable size="large" style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                    <Menu.Item >
                        <Breadcrumb size="mini" className='breadcrumb'>
                            <Breadcrumb.Section active >Home</Breadcrumb.Section>
                        </Breadcrumb>
                    </Menu.Item>
                        
                </Menu>

                {menu.map((item, index) => {
                    if (item.nome === 'Monitoramento' && item.status === 1 && erros.length > 0) {
                        return (
                            <Message
                                key={index}
                                error
                                header="Processos parados:"
                                list={erros} // Exibe os erros aqui
                            />
                        );
                    }
                    return null;
                })}

                <div style={styles.divTab}>

                    { /* Implementação dos grupos nas abas */}
                    <Tab eventKey="home" title="Home" panes={


                        //impede que os grupos se repitam, simplificando a renderização do array por meio do map da coluna
                        [...new Set(menu.map(item => item.grupo))].map(grupo => {

                            return {
                                menuItem: grupo,
                                pane: (
                                    //implementação do conteúdos das abas
                                    <Tab.Pane key={grupo}>
                                        <div  className='tabContent' >
                                            {
                                                //Faz um filtro dos itens presentes em cada grupo; ex: grupo x tem os itens [a,b,c]
                                                menu.filter(item => item.grupo === grupo).map((item, index) => (

                                                    //Renderização dos itens de cada grupo
                                                    <Grid.Column key={index}>
                                                        {item.nome === 'Mercado Livre' ? (
                                                            <a rel="mltoken" href="http://auth.mercadolivre.com.br/authorization?response_type=code&client_id=3344198269232630&redirect_uri=https://adsite.esplane.com.br/mercadolivretoken.asp" >
                                                                <Segment className={item.status ? item.cor : 'desativado'} inverted style={cardcontent}>
                                                                    <Header as="h4" >
                                                                        <Icon name={item.icon} />
                                                                        <Header.Content>{item.nome}</Header.Content>
                                                                    </Header>
                                                                </Segment>
                                                            </a>
                                                        ) : (item.nome === "Monitoramento" ? ('') : (
                                                            <>
                                                                <Link to={item.status ? item.rota : "/Home"} title={item.status ? item.descricao : `${item.descricao} - Você não tem acesso à essa funcionalidade`}>

                                                                    <Segment className={item.status ? item.cor : "desativado"} inverted style={cardcontent}>
                                                                        <Header as='h4'>
                                                                            <Icon name={item.icon} />
                                                                            <Header.Content>{item.nome}</Header.Content>
                                                                        </Header>
                                                                    </Segment>
                                                                </Link>
                                                            </>

                                                        ))
                                                        }
                                                    </Grid.Column>
                                                ))
                                            }

                                        </div>
                                    </Tab.Pane>
                                )
                            }
                        })

                    } renderActiveOnly={false} style={styles.menuTab} defaultActiveIndex={0} />

                </div>

                <style>{`

                    /*deixar o fundo do botão quando o mouse não estiver sobre ele*/

                    .ui.segment.inverted.Change:hover { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.inverted.black.segment{
                        background-color: #f5f5f5 !important;
                    }
                    .ui.segment.inverted.teal { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.orange { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.olive { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.yellow { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.red { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.blue { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.green { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.purple { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.pink { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.brown { 
                        background-color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.grey { 
                        background-color: #f5f5f5 !important;
                    }
                    .ui.segment.inverted.violet {
                        background-color: #f5f5f5 !important;
                    }

                    /*-------------------------------*/

                    .ui.inverted.black.segment:hover>.ui.header{
                        color: #f5f5f5 !important;
                    }

                    .ui.segment.inverted.teal:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.orange:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.olive:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.yellow:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.red:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.blue:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.green:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.purple:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.pink:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.brown:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.grey:hover>.ui.header { 
                        color: #f5f5f5 !important; 
                    }
                    .ui.segment.inverted.violet:hover>.ui.header{
                        color: #f5f5f5 !important;
                    }

                    .ui.segment.inverted.desativado {
                        background-color: transparent !important; 
                        color: #e5e2e2 !important; 
                        border: 1px solid #bbb !important;
                    }


                    /*-------------------------------*/


                    /*deixar o fundo do botão colorido quando o mouse estiver sobre ele*/

                    .ui.segment.black:hover {
                        transition: background-color .3s ease !important;
                        border: 1px solid #000000 !important;
                        background-color: #bbb !important;
                    }

                    .ui.segment.inverted.teal:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.orange:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.olive:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.yellow:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.red:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.blue:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }

                    .ui.segment.inverted.green:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.purple:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.pink:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.brown:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.grey:hover { 
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }
                    .ui.segment.inverted.violet:hover {
                        transition: background-color .3s ease !important;
                        border: 1px solid #000 !important;    
                        background-color: #bbb !important; 
                    }

                    
                    

                    /*-------------------------------*/
                    

                    .ui.inverted.black.segment>.ui.header{
                        color: #000000bb !important;
                    }
                    .ui.inverted.segment.teal>.ui.header {
                        color: #00b5ad !important; 
                    }
                    .ui.segment.inverted.orange>.ui.header{
                        color: #4dad52 !important; 
                    } /*mudança de cor para hover ter uma tonalidade diferente do estado normal e não uma cor diferete*/

                    
                    
                    .ui.segment.inverted.olive>.ui.header{
                        color: #aebd4b !important; 
                    }
                    .ui.segment.inverted.yellow>.ui.header{
                        color: #fbbd08 !important; 
                    }
                    .ui.segment.inverted.red>.ui.header{
                        color: #db2828 !important; 
                    }
                    .ui.segment.inverted.blue>.ui.header{
                        color: #2185d0 !important; 
                    }
                    .ui.segment.inverted.green>.ui.header{
                        color: #21ba45 !important; 
                    }
                    .ui.segment.inverted.purple>.ui.header{
                        color: #a333c8 !important; 
                    }
                    .ui.segment.inverted.pink>.ui.header{
                        color: #e03997 !important; 
                    }
                    .ui.segment.inverted.brown>.ui.header{
                        color: #a5673f !important; 
                    }
                    .ui.segment.inverted.grey>.ui.header{
                        color: #767676 !important; 
                    }
                    .ui.segment.inverted.violet>.ui.header{
                        color: #6435c9 !important; 
                    }

                    /*-------------------------------*/

                    .ui.tabular.menu {
                        width: 100% !important;
                        display: flex !important;
                        align-items: center !important;
                        background-color: transparent !important;
                        border-bottom: none !important;
                    }

                    .ui.inverted.segment.desativado>.ui.header{
                    color: rgba(32, 51, 112, 0.3) !important;}

                    /*Margins laterias no tabMenu */
                    .ui.attached.tabular.menu{
                        margin: 0 42px !important;
                    }

                    /* Estilo da aba NÃO selecionada (texto branco/claro sobre o azul) */
                    .ui.tabular.menu .item {
                        border: none !important;
                        color: rgba(255, 255, 255, 0.7) !important;
                        border-right: 0.5px solid #dddddd3e !important;
                        border-left: 0.5px solid #dddddd3e !important;
                        border-radius: 10px 10px 0 0 !important; /* Arredonda o topo */
                    }
                    .ui.tabular.menu .item:hover {
                        transition: background-color .5s ease !important;
                        background-color: #dddddd1a !important; /* Cor cinza claro */
                        border-right: 0.5px solid #dddddd1a !important;
                        border-left: 0.05px solid #dddddd1a !important;
                        border-radius: 10px 10px 0 0 !important; /* Arredonda o topo */
                    }
                  
                    /* Estilo da aba SELECIONADA (Mesma cor do conteúdo) */
                    .ui.tabular.menu .active.item {
                        background-color: #e9e9e9 !important; /* Cor cinza claro */
                        color: #203370 !important;        /* Texto azul escuro */
                        border: none !important;
                        border-radius: 10px 10px 0 0 !important; /* Arredonda o topo */
                    }

                    /* Estilo card disabled */
                    .ui.tabular.menu .item.disabled:hover {
                        background-color: #203370 !important;
                      
                        border: none !important;
                    }

                    /* Estilo do CONTEÚDO (Pane) */
                    .ui.tab.segment.active {
                        background-color: #e9e9e9 !important; /* Mesma cor da aba ativa */
                        color: #203370 !important;
                        border: none !important;
                        border-radius: 0 0 20px 20px !important; /* Arredonda a base */
                        text-align: center;
                        padding: 2em !important;
                    }

                    /*-------------------------------*/
                    /*Menu Superior*/

                    .ui.menu>.item{
                        border: none !important;
                        padding: 0;
                    }

                    .ui.breadcrumb.menu>.item{
                        border: none !important;
                        padding: 0;
                    }                

                    .ui.breadcrumb .active.section {
                        border: none !important;

                        display: inline-block !important;
                        padding: 1.5em 1.5em !important;
                        border-radius: 0 0 0 5px !important;
                        background-color: #1884af !important;
                        color: #fff !important;
                    }

                    

.tabContent  {
                        display: grid !important;
                        grid-template-columns: repeat(3, 1fr) !important;
                        grid-template-rows: auto !important;
                        grid-gap: 2em !important;
                        width: 100% !important;
                        padding: 0 18px !important;
                    }

                    /*-------------------------------*/

                    /*Estilo responsivo*/
                    @media (max-width: 1020px) {
                        .ui.attached.tabular.menu{
                            margin: 0 18px !important;
                            padding: 0 !important;
                        }
                        .ui.tabular.menu {
                            width: calc(100% - 36px) !important;
                            display: grid !important;
                            grid-template-columns: repeat(3, 1fr) !important;
                            gap: 0.5em 1em!important;
                        }

                        .ui.tabular.menu .item,
                        .ui.tabular.menu .active.item {
                            box-sizing: border-box !important;
                            display: block !important;
                            width: 100% !important;
                            border:none !important;
                            border-bottom: 0.5px solid #dddddd3e !important;
                            border-radius: 10px !important; 
                        }

                        /*.ui.tabular.menu .item:last-child,
                        .ui.tabular.menu .active.item:last-child{
                            border-radius: 10px 10px 0 0 !important;
                            margin-bottom: 0 !important;
                        }*/
                     


                    }

                    @media (max-width: 660px) {
                        .tabContent  {
                            grid-template-columns: repeat(2, 1fr) !important;
                        }
                    }

                    @media (max-width: 515px) {
                        .tabContent  {
                            grid-template-columns: repeat(1, 1fr) !important;
                        }

                        .ui.tabular.menu {
                            width: calc(100% - 36px) !important;
                            display: grid !important;
                            grid-template-columns: repeat(2, 1fr) !important;
                            gap: 0.5em 1em!important;
                        }
                         
                        .ui.tabular.menu .item:last-child,
                        .ui.tabular.menu .active.item:last-child{
                            border-radius: 10px 10px 0 0 !important;
                            margin-bottom: 0 !important;
                        }
                    }


                `}</style>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    menu: state.LoginReducer.menu,
    moniterros: state.MonitoramentoReducer.moniterros
});

export default withRouter(connect(mapStateToProps, {
    monitoramentoErrosAction
})(Home));


const styles = {
    divTab: {
        paddingTop: '2em',
        marginBottom: '30px',
        backgroundColor: '#1884af',
        borderRadius: '20px',
        width: '100%',
        display: 'block',
        height: 'auto'
    }

    , menuTab: {
        padding: '0 0',
        backgroundColor: '#1884af',
        width: '100%',
        borderRadius: '30px',

    }




};



